(function () {
  const STORAGE_KEY = "usv_pincode_delivery";
  // const SCRIPT_URL =
  //   "https://script.google.com/macros/s/AKfycbwVlwW0JDpzIcQDNoq00Jl2qXbs-a3ChoAiBh0NMgiYwyhhU0D9eE3NqXxMw7CJ7jqCrw/exec";
  const SCRIPT_URL = "https://script.google.com/macros/s/AKfycbxHJxmf9BsTcnd9V9kM7T2bRYAJipthtx4OJ09fRqNjs4ZCQwTxt4TByGSOgFpMzivVyw/exec";
  const API_TIMEOUT_MS = 45000;

  const PincodeGate = {
    pincode: null,
    deliveryAvailable: false,
    prepaidAvailable: false,
    codAvailable: false,
    deliveryMessage: "",
    initialized: false,
    pendingAction: null,
    bypassNextSubmit: false,
    bypassNextBuyNow: false,

    init() {
      if (this.initialized) return;
      this.initialized = true;

      this.modal = document.getElementById("pincode-gate-modal");
      this.modalAddButton = this.modal?.querySelector(".pincode-gate-modal__add-btn");

      this.loadFromStorage();
      this.initCheckers();
      this.bindModalEvents();
      this.bindEvents();
      this.observeDOM();
      this.applyVariantState();
    },

    loadFromStorage() {
      try {
        const stored = JSON.parse(
          localStorage.getItem(STORAGE_KEY) ||
            sessionStorage.getItem(STORAGE_KEY) ||
            "null",
        );
        if (stored?.available && stored?.pincode) {
          this.pincode = stored.pincode;
          this.deliveryAvailable = true;
          this.prepaidAvailable = stored.prepaid === true;
          this.codAvailable = stored.cod === true;
          this.deliveryMessage =
            stored.deliveryMessage ||
            this.buildDeliveryMessage(this.prepaidAvailable, this.codAvailable);
          this.saveToStorage();
        }
      } catch (error) {
        localStorage.removeItem(STORAGE_KEY);
        sessionStorage.removeItem(STORAGE_KEY);
      }
    },

    saveToStorage() {
      if (!this.deliveryAvailable || !this.pincode) {
        localStorage.removeItem(STORAGE_KEY);
        sessionStorage.removeItem(STORAGE_KEY);
        return;
      }

      const payload = JSON.stringify({
        pincode: this.pincode,
        available: true,
        prepaid: this.prepaidAvailable,
        cod: this.codAvailable,
        deliveryMessage: this.deliveryMessage,
      });

      localStorage.setItem(STORAGE_KEY, payload);
      sessionStorage.setItem(STORAGE_KEY, payload);
    },

    isAllowed() {
      return this.deliveryAvailable === true;
    },

    isInQuickView(element) {
      return Boolean(element?.closest?.(".wt__quick-buy"));
    },

    usesPDPInlineChecker(element) {
      return this.hasPDPChecker() && !this.isInQuickView(element);
    },

    getBuyNowElement(target) {
      return (
        target?.closest?.(".buy-now-btn") ||
        target?.closest?.(".shopify-payment-button__button") ||
        target?.closest?.(".shopify-payment-button button")
      );
    },

    getModalActionLabel(actionType) {
      if (actionType === "checkout") return "Proceed to checkout";
      if (actionType === "buy-now") return "Buy now";
      return "Add to cart";
    },

    hasPDPChecker() {
      const checkers = document.querySelectorAll('[data-pincode-context="pdp"]');
      for (const checker of checkers) {
        if (!checker.closest(".wt__quick-buy")) return true;
      }
      return false;
    },

    buildDeliveryMessage(prepaid, cod) {
      if (prepaid && cod) {
        return "✓ Delivery available — Prepaid and COD both available. Estimated delivery in 3–5 days.";
      }
      if (prepaid) {
        return "✓ Delivery available — Prepaid only (COD not available). Estimated delivery in 3–5 days.";
      }
      if (cod) {
        return "✓ Delivery available — COD only (Prepaid not available). Estimated delivery in 3–5 days.";
      }
      return "";
    },

    checkPincodeApi(pincode, signal) {
      return new Promise((resolve, reject) => {
        const callbackName =
          "pincodeGateCb_" +
          Date.now() +
          "_" +
          Math.random().toString(36).slice(2, 9);
        let script = null;
        let done = false;

        const cleanup = (fn) => {
          if (done) return;
          done = true;
          clearTimeout(timeoutId);
          signal?.removeEventListener("abort", onAbort);
          delete window[callbackName];
          if (script?.parentNode) script.parentNode.removeChild(script);
          fn();
        };

        const onAbort = () =>
          cleanup(() => reject(new DOMException("Aborted", "AbortError")));

        if (signal?.aborted) {
          reject(new DOMException("Aborted", "AbortError"));
          return;
        }

        signal?.addEventListener("abort", onAbort);

        const timeoutId = setTimeout(() => {
          cleanup(() => reject(new Error("Timeout")));
        }, API_TIMEOUT_MS);

        window[callbackName] = (data) => {
          cleanup(() => resolve(data));
        };

        script = document.createElement("script");
        script.src =
          SCRIPT_URL +
          "?pincode=" +
          encodeURIComponent(pincode) +
          "&callback=" +
          encodeURIComponent(callbackName);
        script.onerror = () => {
          cleanup(() => reject(new Error("Script load failed")));
        };
        document.head.appendChild(script);
      });
    },

    handlePincodeResult(message, pincode, data) {
      if (data.success && data.available) {
        const prepaid = data.prepaid === true;
        const cod = data.cod === true;
        const deliveryMessage = this.buildDeliveryMessage(prepaid, cod);

        this.renderMessage(message, deliveryMessage, "success");
        this.setStatus(pincode, true, { prepaid, cod, deliveryMessage });
        return;
      }

      if (data.success) {
        this.renderMessage(
          message,
          "✗ Sorry, delivery is not available for pincode " + pincode,
          "error",
        );
        this.setStatus(pincode, false);
        return;
      }

      if (data.message?.toLowerCase().includes('api error')) {
        this.renderMessage(
          message,
          "✗ Sorry, delivery is not available for pincode " + pincode,
          "error"
        );
        this.setStatus(pincode, false);
        return;
      }

      this.renderMessage(
        message,
        "Error: " + (data.message || "Unable to verify pincode"),
        "error",
      );
      this.setStatus(pincode, false);
    },

    setStatus(pincode, available, options = {}) {
      this.pincode = pincode || this.pincode;
      this.deliveryAvailable = available === true;
      this.prepaidAvailable = options.prepaid === true;
      this.codAvailable = options.cod === true;
      this.deliveryMessage =
        options.deliveryMessage ||
        this.buildDeliveryMessage(this.prepaidAvailable, this.codAvailable);

      if (this.deliveryAvailable) {
        this.saveToStorage();
        this.onVerified();
      } else {
        localStorage.removeItem(STORAGE_KEY);
        sessionStorage.removeItem(STORAGE_KEY);
        this.hideModalAddButton();
      }

      this.syncCheckerUI();
    },

    clearStatus() {
      this.deliveryAvailable = false;
      this.prepaidAvailable = false;
      this.codAvailable = false;
      this.deliveryMessage = "";
      localStorage.removeItem(STORAGE_KEY);
      sessionStorage.removeItem(STORAGE_KEY);
      this.hideModalAddButton();
      this.syncCheckerUI();
    },

    onVerified() {
      this.hidePDPError();

      if (this.modal?.hidden === false && this.pendingAction) {
        this.showModalAddButton();
      }
    },

    syncCheckerUI() {
      document.querySelectorAll("[data-pincode-checker]").forEach((checker) => {
        const input = checker.querySelector(".pincode-checker-us__input");
        const message = checker.querySelector(".pincode-checker-us__message");

        if (!input || !message) return;

        if (this.isAllowed() && this.pincode) {
          input.value = this.pincode;
          this.renderMessage(
            message,
            this.deliveryMessage ||
              this.buildDeliveryMessage(
                this.prepaidAvailable,
                this.codAvailable,
              ),
            "success",
          );
          return;
        }

        if (!message.classList.contains("pincode-checker-us__message--success")) {
          return;
        }

        message.className = "pincode-checker-us__message";
        message.textContent = "";
      });
    },

    renderMessage(messageEl, text, type) {
      messageEl.textContent = text;
      messageEl.className =
        "pincode-checker-us__message pincode-checker-us__message--" + type;
    },

    initCheckers() {
      document.querySelectorAll("[data-pincode-checker]").forEach((checker) => {
        if (checker.dataset.pincodeBound === "true") return;
        checker.dataset.pincodeBound = "true";

        const input = checker.querySelector(".pincode-checker-us__input");
        const button = checker.querySelector(".pincode-checker-us__check-btn");
        const message = checker.querySelector(".pincode-checker-us__message");

        if (!input || !button || !message) return;

        if (this.pincode) {
          input.value = this.pincode;
        }

        const showLoader = () => {
          button.classList.add("is-loading");
          button.disabled = true;
        };

        const hideLoader = () => {
          button.classList.remove("is-loading");
          button.disabled = false;
        };

        const runCheck = async () => {
          if (checker.dataset.pincodeChecking === "true") return;

          const pincode = input.value.trim();

          if (!pincode) {
            this.renderMessage(message, "Please enter a pincode", "error");
            this.setStatus(pincode, false);
            return;
          }

          if (pincode.length < 4) {
            this.renderMessage(message, "Please enter a valid pincode", "error");
            this.setStatus(pincode, false);
            return;
          }

          checker.dataset.pincodeChecking = "true";
          message.className = "pincode-checker-us__message";
          message.textContent = "";
          showLoader();

          const controller = new AbortController();
          const timeoutId = setTimeout(() => controller.abort(), API_TIMEOUT_MS);

          try {
            const data = await this.checkPincodeApi(pincode, controller.signal);
            this.handlePincodeResult(message, pincode, data);
          } catch (error) {
            const errorMessage =
              error.name === "AbortError" || error.message === "Timeout"
                ? "Request timed out. Please try again."
                : "Unable to check pincode. Please try again.";

            this.renderMessage(message, errorMessage, "error");
            this.setStatus(pincode, false);
          } finally {
            clearTimeout(timeoutId);
            hideLoader();
            checker.dataset.pincodeChecking = "false";
          }
        };

        button.addEventListener("click", runCheck);
        input.addEventListener("keypress", (event) => {
          if (event.key === "Enter") runCheck();
        });
        input.addEventListener("input", () => {
          input.value = input.value.replace(/[^0-9]/g, "");
          this.clearStatus();
          message.className = "pincode-checker-us__message";
          message.textContent = "";
        });
      });

      this.syncCheckerUI();
    },

    getPDPErrorElement() {
      let error = document.querySelector(".pincode-gate__atc-error");

      if (!error) {
        const buyButtons = document.querySelector(
          ".main-product__buy-buttons--container, .wt-product__add-to-cart_form--wrapper",
        );

        if (!buyButtons) return null;

        error = document.createElement("p");
        error.className = "pincode-gate__atc-error";
        error.setAttribute("role", "alert");
        error.textContent =
          "Please check your pincode for delivery availability before adding to cart or buying.";
        buyButtons.parentElement?.insertBefore(error, buyButtons);
      }

      return error;
    },

    showPDPError() {
      const error = this.getPDPErrorElement();
      if (error) error.classList.add("is-visible");

      const checker = document.querySelector('[data-pincode-context="pdp"]');
      checker?.scrollIntoView({ behavior: "smooth", block: "center" });
      checker?.querySelector(".pincode-checker-us__input")?.focus();
    },

    hidePDPError() {
      document
        .querySelector(".pincode-gate__atc-error")
        ?.classList.remove("is-visible");
    },

    openModal(pendingAction) {
      if (!this.modal) return;

      this.pendingAction = pendingAction;
      this.modal.hidden = false;
      this.modal.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";

      if (this.modalAddButton) {
        this.modalAddButton.textContent = this.getModalActionLabel(
          pendingAction?.type,
        );
      }

      if (this.isAllowed()) {
        this.showModalAddButton();
      } else {
        this.hideModalAddButton();
      }

      const input = this.modal.querySelector(".pincode-checker-us__input");
      if (input) {
        input.value = this.pincode || "";
        setTimeout(() => input.focus(), 50);
      }

      this.syncCheckerUI();
    },

    closeModal() {
      if (!this.modal) return;

      this.modal.hidden = true;
      this.modal.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
      this.pendingAction = null;
      this.hideModalAddButton();
    },

    showModalAddButton() {
      if (!this.modalAddButton) return;
      this.modalAddButton.hidden = false;
    },

    hideModalAddButton() {
      if (!this.modalAddButton) return;
      this.modalAddButton.hidden = true;
    },

    bindModalEvents() {
      this.modal?.querySelectorAll("[data-pincode-modal-close]").forEach((el) => {
        el.addEventListener("click", () => this.closeModal());
      });

      this.modalAddButton?.addEventListener("click", () => {
        this.executePendingAction();
      });

      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && this.modal?.hidden === false) {
          this.closeModal();
        }
      });
    },

    executePendingAction() {
      if (!this.pendingAction || !this.isAllowed()) return;

      const action = this.pendingAction;
      this.closeModal();

      if (action.type === "add-to-cart" && action.form) {
        const submitButton =
          action.button || action.form.querySelector('[name="add"]');
        this.bypassNextSubmit = true;

        if (typeof action.form.requestSubmit === "function" && submitButton) {
          action.form.requestSubmit(submitButton);
        } else {
          action.form.submit();
        }

        setTimeout(() => {
          this.bypassNextSubmit = false;
        }, 0);
        return;
      }

      if (action.type === "buy-now") {
        this.proceedBuyNow(action.form, action.button);
        return;
      }

      if (action.type === "checkout") {
        this.bypassNextSubmit = true;

        if (action.form) {
          const checkoutButton =
            action.button ||
            action.form.querySelector('[name="checkout"]') ||
            document.getElementById("CartDrawer-Checkout");

          if (
            typeof action.form.requestSubmit === "function" &&
            checkoutButton
          ) {
            action.form.requestSubmit(checkoutButton);
          } else {
            window.location.href = "/checkout";
          }
        } else {
          window.location.href = "/checkout";
        }

        setTimeout(() => {
          this.bypassNextSubmit = false;
        }, 0);
        return;
      }
    },

    handleAddToCartAttempt(form, button) {
      if (this.bypassNextSubmit) {
        this.bypassNextSubmit = false;
        this.hidePDPError();
        return true;
      }

      if (button?.dataset?.variantDisabled === "true") {
        return true;
      }

      if (this.isAllowed()) {
        this.hidePDPError();
        return true;
      }

      const pendingAction = {
        type: "add-to-cart",
        form,
        button,
      };

      if (this.usesPDPInlineChecker(form || button)) {
        this.showPDPError();
        return false;
      }

      this.openModal(pendingAction);
      return false;
    },

    handleBuyNowAttempt(form, button) {
      if (this.bypassNextBuyNow) {
        this.bypassNextBuyNow = false;
        this.hidePDPError();
        return true;
      }

      if (this.isAllowed()) {
        this.hidePDPError();
        return true;
      }

      const pendingAction = {
        type: "buy-now",
        form,
        button,
      };

      if (this.usesPDPInlineChecker(form || button)) {
        this.showPDPError();
        return false;
      }

      this.openModal(pendingAction);
      return false;
    },

    proceedBuyNow(form, button) {
      const paymentButton =
        (button?.matches?.(
          ".shopify-payment-button__button, .shopify-payment-button button",
        )
          ? button
          : null) ||
        button
          ?.closest?.(".shopify-payment-button")
          ?.querySelector(
            ".shopify-payment-button__button, .shopify-payment-button button",
          ) ||
        form?.querySelector(
          ".shopify-payment-button__button, .shopify-payment-button button",
        );

      if (paymentButton) {
        this.bypassNextBuyNow = true;
        paymentButton.click();
        setTimeout(() => {
          this.bypassNextBuyNow = false;
        }, 0);
        return;
      }

      const submitBtn =
        form?.querySelector('[name="add"]') ||
        form?.querySelector('button[type="submit"]');

      if (!form || !submitBtn) return;

      this.bypassNextSubmit = true;
      submitBtn.click();
      setTimeout(() => {
        window.location.href = "/checkout";
        this.bypassNextSubmit = false;
      }, 500);
    },

    handleCheckoutAttempt(form, button) {
      if (this.bypassNextSubmit || this.isAllowed()) return true;

      const pendingAction = {
        type: "checkout",
        form,
        button,
      };

      if (this.usesPDPInlineChecker(form || button)) {
        this.showPDPError();
        return false;
      }

      this.openModal(pendingAction);
      return false;
    },

    applyVariantState() {
      document
        .querySelectorAll('form[data-type="add-to-cart-form"] [name="add"]')
        .forEach((button) => {
          const variantDisabled = button.dataset.variantDisabled === "true";

          if (variantDisabled) {
            button.setAttribute("disabled", "disabled");
          } else {
            button.removeAttribute("disabled");
          }
        });
    },

    bindEvents() {
      document.addEventListener(
        "click",
        (event) => {
          const addButton = event.target.closest('[name="add"]');
          if (addButton) {
            const form = addButton.closest("form");
            if (!form) return;
            if (addButton.dataset.variantDisabled === "true") return;
            if (this.bypassNextSubmit) return;
            if (this.isAllowed()) return;

            event.preventDefault();
            event.stopPropagation();
            this.handleAddToCartAttempt(form, addButton);
            return;
          }

          const buyNowEl = this.getBuyNowElement(event.target);
          if (buyNowEl) {
            if (this.bypassNextBuyNow) return;
            if (this.isAllowed()) return;

            const form =
              buyNowEl.closest("form") ||
              document.querySelector('form[data-type="add-to-cart-form"]');

            if (!this.handleBuyNowAttempt(form, buyNowEl)) {
              event.preventDefault();
              event.stopPropagation();
              event.stopImmediatePropagation();
            }
            return;
          }

          const checkoutButton = event.target.closest(
            '[name="checkout"], #CartDrawer-Checkout, .cart__checkout',
          );
          if (checkoutButton) {
            if (this.bypassNextSubmit || this.isAllowed()) return;

            const form =
              checkoutButton.closest("form") ||
              document.getElementById(checkoutButton.getAttribute("form"));

            event.preventDefault();
            event.stopPropagation();
            this.handleCheckoutAttempt(form, checkoutButton);
            return;
          }

          const checkoutLink = event.target.closest('a[href*="/checkout"]');
          if (checkoutLink) {
            if (this.bypassNextSubmit || this.isAllowed()) return;

            event.preventDefault();
            event.stopPropagation();
            this.openModal({ type: "checkout", form: null, button: null });
          }
        },
        true,
      );

      document.addEventListener(
        "submit",
        (event) => {
          const form = event.target;
          if (!(form instanceof HTMLFormElement)) return;

          const addButton = form.querySelector('[name="add"]');
          const checkoutButton =
            form.querySelector('[name="checkout"]') ||
            (event.submitter?.name === "checkout" ? event.submitter : null);

          if (addButton) {
            if (addButton.dataset.variantDisabled === "true") return;
            if (this.bypassNextSubmit) return;
            if (this.isAllowed()) return;

            event.preventDefault();
            event.stopImmediatePropagation();
            this.handleAddToCartAttempt(form, addButton);
            return;
          }

          if (checkoutButton) {
            if (this.bypassNextSubmit || this.isAllowed()) return;

            event.preventDefault();
            event.stopImmediatePropagation();
            this.handleCheckoutAttempt(form, checkoutButton);
          }
        },
        true,
      );

      document.addEventListener("variantChangeEnd", () => this.applyVariantState());
      document.addEventListener("shopify:section:load", () => {
        this.initCheckers();
        this.applyVariantState();
      });
    },

    observeDOM() {
      let timeout;
      const observer = new MutationObserver((mutations) => {
        const hasNewChecker = mutations.some((mutation) =>
          [...mutation.addedNodes].some(
            (node) =>
              node.nodeType === 1 &&
              (node.matches?.("[data-pincode-checker]") ||
                node.querySelector?.("[data-pincode-checker]")),
          ),
        );

        if (!hasNewChecker) return;

        clearTimeout(timeout);
        timeout = setTimeout(() => {
          this.initCheckers();
          this.applyVariantState();
        }, 150);
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    },
  };

  window.PincodeGate = PincodeGate;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => PincodeGate.init());
  } else {
    PincodeGate.init();
  }
})();
